<template>
  <div class="animated fadeIn">
    <div v-if="!organization.id">
      <p>organization not found, or you do not have access to this organization in the given Org/Group context.</p>
    </div>
    <div v-if="organization.id" class='personPage'>
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto">
          <h4 class="card-title mb-0">{{ organization.title }}</h4>
          <div class="small text-muted">Added {{ getCreatedAt() }}</div>
        </b-col>
        <b-col cols="auto">
          <router-link :to="'/admin/organizations/' + organization.id + '/edit'">
            <b-button class="mx-0">Edit</b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div>
            <b-card no-body>
              <div slot="header">
                <strong>Information</strong>
              </div>
              <b-card-body>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">ID</small>
                  <br>
                  <h4>{{ organization.id }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Organization Name</small>
                  <br>
                  <h4>{{ organization.title }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Street</small>
                  <br>
                  <h4>{{ organization.mailingStreet }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">City</small>
                  <br>
                  <h4>{{ organization.mailingCity }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">County / Parish</small>
                  <br>
                  <h4>{{ organization.county }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">State</small>
                  <br>
                  <h4>{{ organization.mailingStateAbbreviation }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Postal Code</small>
                  <br>
                  <h4>{{ organization.mailingPostalCode }}</h4>
                </div>
                <div class="pb-4" v-if="organizationTypes.length > 0">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Organization Type</small>
                  <br>
                  <div v-for="organization in organizationTypes" :key="organization" flush>
                    <h4>{{ organization }}</h4>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="12">
              <OrganizationGroups  :organizationId="orgId" :memberGroups="organization.memberGroups"></OrganizationGroups>

              <OrganizationMembers  :organizationId="orgId" :organizationName="organization.title"></OrganizationMembers>

              <ProgramList :organizationId="orgId" :orgState="organization.mailingStateAbbreviation" :defaultProgram="organization.defaultProgram" :programs="organization.programs"></ProgramList>

              <LocationList :organizationId="orgId" :defaultLocation="organization.defaultLocation" :locations="organization.locations"></LocationList>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Meta</b>
                </b-card-header>

                <b-list-group flush>
                  <b-list-group-item class="small text-muted">
                    <b>Created At: </b> {{ getCreatedAt() }}
                    <div v-if="_.isObject(organization.createdBy)">
                      <b> by: </b> {{ _.get(organization, 'createdBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>

                  <b-list-group-item class="small text-muted">
                    <b>Last Updated: </b> {{ getLastUpdateDate() }}
                    <div v-if="_.isObject(organization.updatedBy)">
                      <b> by: </b> {{ _.get(organization, 'updatedBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import OrganizationGroups from '@/components/Admin/OrganizationGroups'
  import OrganizationMembers from '@/components/Admin/OrganizationMembers'
  import ProgramList from '@/components/Admin/ProgramList'
  import LocationList from '@/components/Admin/LocationList'

  export default {
    name: 'Organization',
    components: {
      OrganizationGroups,
      OrganizationMembers,
      ProgramList,
      LocationList
    },
    computed: {
      ...mapGetters({
        organization: 'getViewOrganization'
        // countries: 'getCountries', // ISO-3166-1-Alpha-3Codes data
        // userCurrentContext: 'userCurrentContext'
      }),
      orgId: function () {
        return parseInt(this.$route.params.id, 10)
      },
      organizationTypes: function () {
        return !this.organization.organizationTypes ? [] : JSON.parse(this.organization.organizationTypes)
      }
    },
    methods: {
      getCreatedAt () {
          const organization = this.organization
          if (organization.createdAt && organization.createdAt.includes('T')) {
              return this.$utils.formatDate(organization.createdAt)
          } else if (organization.createdAt) {
              return this.$utils.unixToHuman(organization.createdAt / 1000)
          } else {
            return 'Unknown'
          }
        },
        getLastUpdateDate () {
          const organization = this.organization
          if (organization.updatedAt && organization.updatedAt.includes('T')) {
              return this.$utils.formatDate(organization.updatedAt)
          } else if (organization.updatedAt) {
              return this.$utils.unixToHuman(organization.updatedAt / 1000)
          }
        },
      populateRecords: function () {
        this.$store.dispatch('getOrganizationView', {
          id: this.orgId
        })
      }
    },
    data: function () {
      return {
        timestamp: ''
      }
    },
    beforeDestroy: function () {
      this.$store.commit('resetOrgView')
    },
    created: function () {
      this.populateRecords()
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1100px) {
    .card-header .btn-sm .plus {
      display: none;
    }
  }

  @media screen and (max-width: 1100px) {
    .card-header .btn-sm {
      line-height: 16px;
    }

    .card-header .btn-sm .button-text {
      display: none;
    }

    .card-header .btn-sm .plus {
      display: inline;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/Organization.vue